
/* injects from baggage-loader */

'use strict';

import StarsComponent from './stars.component';

const StarsModule = angular.module('stars-module',[]);

StarsModule.component('redStars', StarsComponent);

export default StarsModule;


// WEBPACK FOOTER //
// ./src/app/components/stars/stars.module.js